<template>
<div class="mt-3">
    <div class="flex justify-between items-center bg-indigo-600 rounded-lg py-3 px-3">
        <h2 class="text-white text-lg">Récap mensuel {{ displayedYear }}</h2>
    </div>
    <div class="overflow-x-auto" v-if="mois && mois.length">
        <table class="w-full border-t-2 border-gray-600 mt-2">
            <thead>
                <tr>
                    <th scope="col" class="text-left py-2 px-2 text-xs font-normal text-gray-500 dark:text-gray-400">Mois</th>
                    <th scope="col" class="text-right py-2 px-2 text-xs font-normal text-gray-500 dark:text-gray-400">Loyers</th>
                    <th scope="col" class="text-right py-2 px-2 text-xs font-normal text-gray-500 dark:text-gray-400">Charges</th>
                    <th scope="col" class="text-right py-2 px-2 text-xs font-normal text-gray-500 dark:text-gray-400">Taxe foncière</th>
                    <th scope="col" class="text-right py-2 px-2 text-xs font-normal text-gray-500 dark:text-gray-400">Prêts</th>
                    <th scope="col" class="text-right py-2 px-2 text-xs font-normal text-gray-500 dark:text-gray-400">Net</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="m in moisDecroissant" :key="m.month" class="border-t border-gray-200 dark:border-gray-800">
                    <td class="py-2 px-2 text-sm text-gray-700 dark:text-gray-300 whitespace-nowrap">{{ monthLabel(m.month) }}</td>
                    <td class="py-2 px-2 text-sm text-right text-gray-700 dark:text-gray-300 whitespace-nowrap">{{ format(m.loyers) }}</td>
                    <td class="py-2 px-2 text-sm text-right text-gray-700 dark:text-gray-300 whitespace-nowrap">{{ format(m.charges) }}</td>
                    <td class="py-2 px-2 text-sm text-right text-gray-700 dark:text-gray-300 whitespace-nowrap">{{ format(m.taxe_fonciere) }}</td>
                    <td class="py-2 px-2 text-sm text-right text-gray-700 dark:text-gray-300 whitespace-nowrap">{{ format(m.prets) }}</td>
                    <td class="py-2 px-2 text-sm text-right font-medium whitespace-nowrap" :class="m.net >= 0 ? 'text-green-600 dark:text-green-400' : 'text-red-600 dark:text-red-400'">{{ format(m.net) }}</td>
                </tr>
            </tbody>
        </table>
    </div>
    <p v-else class="text-sm text-indigo-400 my-4 text-center">Aucune donnée disponible.</p>
</div>
</template>

<script>
const MONTH_LABELS = ['Janv.', 'Fév.', 'Mars', 'Avr.', 'Mai', 'Juin', 'Juil.', 'Août', 'Sept.', 'Oct.', 'Nov.', 'Déc.'];

export default {
    props: {
        mois: {
            type: Array,
            default: () => []
        }
    },

    computed: {
        // The backend picks the most recent year with actual data, which may not be the calendar's current year.
        displayedYear() {
            return this.mois && this.mois.length ? this.mois[0].year : new Date().getFullYear();
        },

        moisDecroissant() {
            return [...this.mois].reverse();
        }
    },

    methods: {
        monthLabel(month) {
            return MONTH_LABELS[parseInt(month, 10) - 1] || month;
        },

        format(value) {
            return `${Number(value || 0).toLocaleString('fr-FR', {minimumFractionDigits: 2, maximumFractionDigits: 2})} €`;
        }
    }
};
</script>
